module.exports = __webpack_public_path__ + "img/arrow-up.31192364.svg";